// Service to provide access to the initialized i18n instance throughout the app
let i18nInstance = null;

export const setI18n = (i18n) => {
  i18nInstance = i18n;
};

export const getI18n = () => i18nInstance;

// Helper function to safely get translation
export const t = (key, options) => {
  if (i18nInstance && i18nInstance.t) {
    return i18nInstance.t(key, options);
  }
  // Fallback: return the key if i18n is not initialized
  return key;
};

export const getCurrentLocale = () => {
    const i18n = getI18n();
    const fullLocale = i18n?.language || 'en';
    const currentLocale = fullLocale.split('-')[0];

    return currentLocale;
}

export const getdddMMMDoFormat = () => {
    const locale = getCurrentLocale();

		switch(locale) {
			case 'en':
				return 'ddd MMM Do';
			case 'de':
				return 'ddd D. MMM';
			default:
				return 'ddd D MMM';
		}

}
